import { Box, Collapse, Group, Text, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { CollapsableResourceFolderProps } from './types';
import ResourceIcon from '../../ResourceIcon';
import { FONT_WEIGHT } from '@app/shared/ui-kit/fonts';
import { ActionIcon } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';

function CollapsableResourceFolder(props: CollapsableResourceFolderProps) {
  const [opened, { toggle }] = useDisclosure(false);
  const resourceName = `(${props.resource.index}) ${props.resource.name}`;

  return (
    <Box>
      <Group
        wrap="nowrap"
        gap={6}
        style={{
          paddingLeft: `${props.level * 20}px`, // 20px indent per level
          height: 60,
        }}
      >
        <Box w={30}>
          {props.resource.subRows && props.resource.subRows.length > 0 && (
            <ActionIcon
              onClick={toggle}
              variant="subtle"
              color="blackroomGray"
              style={{
                transform: opened ? 'rotate(90deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease-in-out',
              }}
            >
              <IconChevronRight />
            </ActionIcon>
          )}
        </Box>
        <Box pt="0.25rem">
          <ResourceIcon
            resource={props.resource}
            folderExpanded={opened}
            withColor
          />
        </Box>
        <Tooltip label={resourceName} openDelay={500}>
          <Text
            onClick={() => props.onFolderClick?.(props.resource)}
            styles={{
              root: { whiteSpace: 'nowrap', cursor: 'pointer', flex: 1 },
            }}
            size="sm"
            truncate
            fw={FONT_WEIGHT.bold}
          >
            {resourceName}
          </Text>
        </Tooltip>
      </Group>

      {props.resource.subRows && (
        <Collapse in={opened}>
          {props.resource.subRows.map((r) => (
            <CollapsableResourceFolder
              key={r.id}
              resource={r}
              level={props.level + 1}
              onFolderClick={props.onFolderClick}
            />
          ))}
        </Collapse>
      )}
    </Box>
  );
}

export default CollapsableResourceFolder;
